import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { type ThemePalette } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoaderButtonComponent } from '../loader-button/loader-button.component';

@Component({
  selector: 'pt-loader-button-with-menu',
  templateUrl: './loader-button-with-menu.component.html',
  styleUrls: ['./loader-button-with-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    LoaderButtonComponent,
  ],
  host: {
    class: 'flex flex-row',
  },
})
export class LoaderButtonWithMenuComponent {
  readonly label = input('');
  readonly loadingLabel = input('Loading...');
  readonly icon = input<string>();
  readonly tooltip = input<string>();
  readonly type = input<'stroked' | 'flat' | 'raised'>('stroked');
  readonly disabled = input(false, { transform: booleanAttribute });
  readonly loading = input(false, { transform: booleanAttribute });
  readonly checked = input(false, { transform: booleanAttribute });
  readonly color = input<ThemePalette>();
  readonly externalMenu = input<MatMenu>();

  readonly isDisabled = computed(() => this.disabled() || this.loading());
  readonly displayLabel = computed(() =>
    this.loading() ? this.loadingLabel() : this.label()
  );

  readonly buttonClick = output<void>();
}
